var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import client from "@irati/utils/services/apollo";
import tagService from "@irati/tag/services/tag";
import dealCategoriesQuery, { dealCategoriesKey } from "./queries/dealCategories";
import dealCategoriesForCurrentPackageQuery, { dealCategoriesForCurrentPackageKey } from "./queries/dealCategoriesForCurrentPackage";
var DealCategories = /** @class */ (function () {
    function DealCategories() {
    }
    DealCategories.prototype.get = function (id, options) {
        if (options === void 0) { options = {}; }
        return tagService.get({ id: id, withChildren: true }, options);
    };
    DealCategories.prototype.list = function (variables, options) {
        if (options === void 0) { options = {}; }
        return client.query(__assign(__assign({}, options), { query: dealCategoriesQuery, variables: variables })).then(function (_a) {
            var data = _a.data;
            return data[dealCategoriesKey].results;
        });
    };
    DealCategories.prototype.listForCurrentPackage = function (options) {
        if (options === void 0) { options = {}; }
        return client.query(__assign(__assign({}, options), { query: dealCategoriesForCurrentPackageQuery })).then(function (_a) {
            var data = _a.data;
            return data[dealCategoriesForCurrentPackageKey].results;
        });
    };
    return DealCategories;
}());
export default new DealCategories();
